import React from "react";
import { GiMeal } from "react-icons/gi";
import { FaUsers, FaUtensils, FaConciergeBell } from "react-icons/fa";

export const links = [
  {
    id: 2,
    text: "Kontakt",
    url: "/about",
  },
  {
    id: 3,
    text: "Produkty",
    url: "/pronajem-party-stanu-vybaveni",
  },
  {
    id: 4,
    text: "Catering",
    url: "/barovy-catering-na-akce",
  },
];

export const services = [
  {
    id: 1,
    icon: <GiMeal />,
    title: "Domácí gastronomie",
    text: "Vaříme z kvalitních surovin, domácí i světovou gastronomii pro vaše svatby, oslavy a firemní akce.",
  },
  {
    id: 2,
    icon: <FaUsers />,
    title: "Profesionální tým",
    text: "V týmu máme pouze proškolené odborníky v oboru, kteří se postarají o hladký průběh celé akce.",
  },
  {
    id: 3,
    icon: <FaUtensils />,
    title: "Pronájem restaurace",
    text: "Zajistíme vám pronájem partnerské Arabela restaurace v kempu Konopáč u Heřmanova Městce, s možností ubytování.",
  },
  {
    id: 4,
    icon: <FaConciergeBell />,
    title: "Nabídka na míru",
    text: "Na vaše přání vám zařídíme nabídku přesně podle vašich představ — od jídla po výzdobu.",
  },
];

export const products_url = "https://course-api.com/react-store-products";

export const single_product_url = `https://course-api.com/react-store-single-product?id=`;
